import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VideoRacconto = () => {
  const { t } = useLang();
  const [video, setVideo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site/video`).then((res) => setVideo(res.data)).catch(() => {});
  }, []);

  if (!video) return null;

  return (
    <section className="relative py-24 sm:py-28" data-testid="video-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="inline-flex items-center gap-2 font-mono-ed text-xs uppercase tracking-[0.22em] text-[#0284C7]">
            <Play size={13} /> {t.video.label}
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#0B2530] mt-4">
            {t.video.h2a}<em className="font-serif-ed italic font-medium text-[#E8894B]">{t.video.h2em}</em>
          </h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.97 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 rounded-[2rem] overflow-hidden img-frame border border-white"
        >
          <video controls preload="metadata" className="w-full aspect-video bg-[#08222E]" data-testid="hero-video">
            <source src={`${API}/files/${video.storage_path}`} type={video.content_type} />
          </video>
        </motion.div>
      </div>
    </section>
  );
};
